export default __webpack_public_path__ + "static/media/VkenLogo.609b4706.png";